/* eslint-disable no-param-reassign */
export default {
  loadFromStorage(state) {
    const sidenavCollapsed = localStorage.getItem('sidenavCollapsed');
    state.sidenavCollapsed = sidenavCollapsed === 'true' || false;

    state.userData = JSON.parse(localStorage.getItem('userData'));

    state.theme = 'light-theme';
  },
  setUserData(state, userData) {
    state.userData = userData;
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  setClientInfo(state, clientInfo) {
    state.clientInfo = clientInfo;
  },
  setSidenavCollapsed(state, sidenavCollapsed) {
    localStorage.setItem('sidenavCollapsed', sidenavCollapsed);
    state.sidenavCollapsed = sidenavCollapsed;
  },
  setShowTutorial(state, show) {
    state.showTutorial = show;
  },
  setTheme(state, theme) {
    state.theme = theme;
  },
};
